module.exports = __webpack_public_path__ + "ce5b5c264f79a251763932fb618132f6.svg";